module.exports = __webpack_public_path__ + "img/logo.b8f3aa9f.png";